import React, { useState } from 'react';

const RecapInningBreakdown = ({ innings, awayAbbr, homeAbbr }) => {
  const [selected, setSelected] = useState(null);
  if (!innings?.length) return (
    <div className="text-[#658d71] text-xs text-center py-6 uppercase tracking-widest">No inning data</div>
  );

  const sel = selected !== null ? innings[selected] : null;

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-9 gap-1">
        {innings.map((inn, i) => {
          const aR = inn.away?.runs ?? 0;
          const hR = inn.home?.runs ?? 0;
          const hasRuns = aR > 0 || hR > 0;
          return (
            <button
              key={i}
              onClick={() => setSelected(selected === i ? null : i)}
              className={`flex flex-col items-center border transition-all py-1.5 text-[10px] font-black ${selected === i ? 'bg-[#386646] border-[#d8ceb3]' : hasRuns ? 'border-[#a9c9b1] bg-[rgba(169,201,177,0.08)]' : 'border-[#658d71] bg-transparent'} hover:border-[#d8ceb3]`}
            >
              <span className="text-[#658d71] text-[8px] font-bold">{i + 1}</span>
              <span className={`tabular-nums ${aR > 0 ? 'text-[#a9c9b1]' : 'text-[#3a5c47]'}`}>{aR}</span>
              <span className={`tabular-nums ${hR > 0 ? 'text-[#c4333e]' : 'text-[#3a5c47]'}`}>{hR}</span>
            </button>
          );
        })}
      </div>
      <div className="flex justify-center gap-4 text-[9px] uppercase tracking-widest font-bold">
        <span className="text-[#a9c9b1]">{awayAbbr} (top)</span>
        <span className="text-[#c4333e]">{homeAbbr} (bot)</span>
      </div>
      {sel && (
        <div className="border border-[#658d71] p-3 bg-[rgba(0,0,0,0.1)] grid grid-cols-2 gap-3 text-xs">
          {[['away', awayAbbr, '#a9c9b1'], ['home', homeAbbr, '#c4333e']].map(([side, abbr, color]) => (
            <div key={side} className="flex flex-col gap-1">
              <span className="text-[9px] font-bold uppercase tracking-widest" style={{ color }}>{abbr}</span>
              {[['Runs', sel[side]?.runs], ['Hits', sel[side]?.hits], ['Errors', sel[side]?.errors], ['LOB', sel[side]?.leftOnBase]].map(([k, v]) => (
                <div key={k} className="flex justify-between border-b border-[rgba(101,141,113,0.2)] pb-0.5">
                  <span className="text-[#658d71] font-bold text-[9px] uppercase tracking-wider">{k}</span>
                  <span className="text-white font-bold tabular-nums">{v ?? '--'}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecapInningBreakdown;